export enum SystemCredentialsActionTypes {
  GET_SYSTEM_CREDENTIALS = "GET_SYSTEM_CREDENTIALS",
  GET_SYSTEM_CREDENTIALS_SUCCESS = "GET_SYSTEM_CREDENTIALS_SUCCESS",
  GET_SYSTEM_CREDENTIALS_FAIL = "GET_SYSTEM_CREDENTIALS_FAIL",
}

export type SystemCredentials = {
  subscriptionKey: string;
  instrumentationKey: string;
};
